export const environment = {
  env: 'PROD',
  production: true,
  // serverBaseUrl: 'http://bklapreferida.vaixs.org/public/api',
  // serverUrl: 'http://bklapreferida.vaixs.org/public/api',
  // imgUrl: 'http://bklapreferida.vaixs.org/public/images/'
  //  serverBaseUrl: 'http://bkstockprueba.vaixs.org/public/api',
  // serverUrl: 'http://bkstockprueba.vaixs.org/public/api',
  // imgUrl: 'http://bkstockprueba.vaixs.org/public/images/'
  // serverBaseUrl: 'http://bkelpreferido.vaixs.org/public/api',
  // serverUrl: 'http://bkelpreferido.vaixs.org/public/api',
  // imgUrl: 'http://bkelpreferido.vaixs.org/public/images/'
  serverBaseUrl: 'https://bkelpreferido.webolivia.com/public/api',
  serverUrl: 'https://bkelpreferido.webolivia.com/public/api',
  imgUrl: 'https://bkelpreferido.webolivia.com/public/images/'
};
